export const globalQuillConfig = {
  sanitize: true,
  clipboard: {
    matchVisual: false
  },
  modules: {
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'],
      ['blockquote'],
      [{ header: 1 }, { header: 2 }],
      [{ list: 'ordered' }, { list: 'bullet' }],
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      ['clean'],
      ['link']
    ]
  }
};
